import {Directive, EventEmitter, Input, OnChanges, Output,} from '@angular/core';
import {Subject} from 'rxjs';

export type ValgSortType = 'number' | 'alphabetic' | 'date';
export type ValgSortDir = 'asc' | 'desc' | 'none';
// eslint-disable-next-line
export type ValgSortFunc = (current: any, next: any, direction?:ValgSortDir|undefined) => number;

export interface ValgSortable extends Sort {
  dataType?: ValgSortType;
  reset: () => void;
}

export interface Sort {
  id: string;
  sortDirection?: ValgSortDir;
  sortFunction?: ValgSortFunc;
  sortDiscriminator?: string;
}

@Directive({
  selector: '[valgSort]',
  exportAs: 'valgSort',
})
export class ValgSortDirective implements OnChanges {
  @Output() readonly sortChange: EventEmitter<Sort> =
    new EventEmitter<Sort>();

  sortables = new Map<string, ValgSortable>();
  readonly _stateChanges = new Subject<void>();

  @Input() activeId: string;
  @Input() activeDir: ValgSortDir = 'none';

  constructor() {
    this.activeId = '';
  }

  register(sortable: ValgSortable): void {
    this.sortables.set(sortable.id, sortable);
  }

  deregister(sortable: ValgSortable): void {
    this.sortables.delete(sortable.id);
  }

  sort(sortable: ValgSortable): void {
    this.activeId = sortable.id;
    this.activeDir = sortable.sortDirection ?? 'none';
    this.sortables.forEach((sort) => {
      if (sort.id != sortable.id) {
        sort.reset();
      }
    });

    this.sortChange.emit({ id: this.activeId, sortDirection: this.activeDir, sortFunction: sortable.sortFunction, sortDiscriminator: sortable.sortDiscriminator });
    this._stateChanges.next();
  }

  ngOnChanges(): void {
    this._stateChanges.next();
  }
}
